module.exports = __webpack_public_path__ + "img/Keep customers better informed of product updates.afdf501d.gif";